import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { BqAvatar, BqButton, BqDivider, BqDropdown, BqOption } from '@beeq/react'

export const StyledHeaderWrapper = styled.header`
  min-width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--bq-spacing-m) 96px;
  color: var(--bq-neutral-800);
  line-height: var(--bq-font-line-height--regular);
  font-size: var(--bq-font-size--m);
  font-weight: var(--bq-font-weight--medium);
`

export const StyledLink = styled(Link)`
  padding: var(--bq-spacing-s) 0;
`

export const StyledWrapper = styled.div`
  display: flex;
  align-items: center;

  bq-icon[name='bell'] {
    cursor: pointer;
    padding: var(--bq-spacing-s);
    border-radius: var(--bq-radius--m);
  }
`

export const StyledBqDropdown = styled(BqDropdown)`
  ::part(panel) {
    box-shadow: 0px 10px 48px -16px rgba(0, 0, 0, .4);
    padding: 0;
  }
`

export const StyledBqButton = styled(BqButton)`
  & span {
    margin: 0 var(--bq-spacing-xs2);
  }
`

export const StyledIconBqButton = styled(BqButton)`
 ::part(button) {
    padding-left: 0;
    padding-right: 0;
 }
`

export const StyledAvatar = styled(BqAvatar)`
::part(base) {
  height: var(--bq-spacing-l);
  width: var(--bq-spacing-l);
}
::part(text) {
  padding-top: var(--bq-spacing-xs3);
}
`

export const StyledBqOption = styled(BqOption)`
font-weight: var(--bq-font-weight--regular);
margin: var(--bq-spacing-xs);
::part(base) {
  padding: var(--bq-spacing-xs) var(--bq-spacing-s);
}
`

export const StyledBqDivider = styled(BqDivider)`
  ::part(dash-start) {
    stroke: var(--bq-endava-grey-50);
  }
`
